import React, { useRef, useState, useEffect } from "react";
import { Tooltip } from "antd";

import Localize from "components/service/localize";

const CollectGraphicsCommentBlock = ({ stand }) => {
    const ref = useRef(null);
    const [isOverflowed, setIsOverflowed] = useState(false);
    const comment = stand?.comment;

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        setIsOverflowed(el.scrollHeight > el.clientHeight + 2);
    }, [comment]);

    const content = (
        <div
            ref={ref}
            className="collect-graphics-comment-block"
            style={{ userSelect: 'text' }}
        >
            <strong><Localize>GLOBAL.Comment</Localize>:</strong> { " " }
            {comment ? comment : "—"}
        </div>
    );

    return isOverflowed && comment ? (
        <Tooltip title={comment} placement="top">
            {content}
        </Tooltip>
    ) : (
        content
    );
};

export default CollectGraphicsCommentBlock;